import type { CustomerHasFilter, MeetingType } from "@przezmorze/api-types";
import type { SelectedTag } from "../../components/tagSelect/TagSelect";
import type { CustomerStatus } from "../customersApi";

/** Filters of the client list; scalar keys match the `/customers-overview/summaries` query parameters, empty string
 * meaning "not set". */
export interface ClientFilters {
  readonly query: string;
  readonly status: CustomerStatus | "";
  readonly travelPayStatus: CustomerStatus | "";
  readonly accountManagerId: string;
  readonly voivodeship: string;
  readonly city: string;
  readonly tags: SelectedTag[];
  /** Tags the customer must not have. */
  readonly excludedTags: SelectedTag[];
  readonly calculationFrom: string;
  readonly orderFrom: string;
  readonly meetingType: MeetingType | "";
  /** Predefined on/off filters, applied immediately when toggled. */
  readonly has: CustomerHasFilter[];
  readonly meetingFrom: string;
  readonly meetingTo: string;
  readonly notePrzezmorzeFrom: string;
  readonly notePrzezmorzeTo: string;
  readonly noteTravelPayFrom: string;
  readonly noteTravelPayTo: string;
}

export const emptyClientFilters: ClientFilters = {
  query: "",
  status: "",
  travelPayStatus: "",
  accountManagerId: "",
  voivodeship: "",
  city: "",
  tags: [],
  excludedTags: [],
  calculationFrom: "",
  orderFrom: "",
  meetingType: "",
  has: [],
  meetingFrom: "",
  meetingTo: "",
  notePrzezmorzeFrom: "",
  notePrzezmorzeTo: "",
  noteTravelPayFrom: "",
  noteTravelPayTo: "",
};

export const MEETING_TYPE_LABELS: Record<MeetingType, string> = {
  ONLINE: "Online",
  OFFICE: "W biurze",
};

export interface PredefinedFilter {
  readonly value: CustomerHasFilter;
  readonly label: string;
  readonly description: string;
}

export const PREDEFINED_FILTERS: readonly PredefinedFilter[] = [
  { value: "ORDERS", label: "Zamówienia", description: "Ma zamówienie, które nie jest anulowane ani do anulacji" },
  { value: "CALCULATIONS", label: "Kalkulacje", description: "Ma jakąkolwiek kalkulację" },
  { value: "NOTES", label: "Notatki", description: "Ma choć jedną notatkę" },
  { value: "CONTACTS", label: "Osoby kontaktowe", description: "Ma minimum jedną przypisaną osobę kontaktową" },
];

export function tagFilterValue(tag: SelectedTag): string {
  return `${tag.category}:${tag.value}`;
}
